"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _faFilter = require("@fortawesome/pro-regular-svg-icons/faFilter");

var S = _interopRequireWildcard(require("./styled"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var noop = function noop() {};

var Filters = function Filters(_ref) {
  var _ref$instance = _ref.instance,
      headers = _ref$instance.headers,
      columns = _ref$instance.columns,
      setAllFilters = _ref$instance.setAllFilters,
      gotoPage = _ref$instance.gotoPage,
      _ref$onApplyFilters = _ref.onApplyFilters,
      onApplyFilters = _ref$onApplyFilters === void 0 ? noop : _ref$onApplyFilters,
      _ref$onResetFilters = _ref.onResetFilters,
      onResetFilters = _ref$onResetFilters === void 0 ? noop : _ref$onResetFilters,
      selectedFilters = _ref.selectedFilters,
      setSelectedFilters = _ref.setSelectedFilters,
      showFilterToggle = _ref.showFilterToggle,
      _ref$defaultFilters = _ref.defaultFilters,
      defaultFilters = _ref$defaultFilters === void 0 ? false : _ref$defaultFilters;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      hasSelectedFilters = _useState4[0],
      setHasSelectedFilters = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      filterOptions = _useState6[0],
      setFilterOptions = _useState6[1];

  var path = window.location.pathname;
  var claims = window.localStorage.getItem('claims');
  var user = claims ? JSON.parse(claims)['id'] : '';
  (0, _react.useEffect)(function () {
    var storedFilters = window.localStorage.getItem("".concat(user, "_filters").concat(path));

    if (storedFilters) {
      storedFilters = JSON.parse(storedFilters);
      setSelectedFilters(storedFilters);
    } else if (defaultFilters) {
      var _selectedFilters = {};
      Object.keys(defaultFilters).forEach(function (filter) {
        return _selectedFilters[filter] = true;
      });
      setSelectedFilters(_selectedFilters);
    }
  }, []);
  (0, _react.useEffect)(function () {
    var selected = Object.values(selectedFilters).some(function (filter) {
      return filter === true;
    });
    setHasSelectedFilters(selected);
  }, [selectedFilters]);
  (0, _react.useEffect)(function () {
    var availableFilters = columns.filter(function (col) {
      return col['Filter'] && col.render('Filter');
    }).map(function (col) {
      return {
        label: col.Header,
        value: col.id
      };
    });
    setFilterOptions(availableFilters);
  }, [columns]);

  var handleChange = function handleChange(e) {
    var value = e.target.value;

    var filters = _objectSpread(_objectSpread({}, selectedFilters), {}, _defineProperty({}, value, !selectedFilters[value]));

    window.localStorage.setItem("".concat(user, "_filters").concat(path), JSON.stringify(filters));
    setSelectedFilters(filters);
  };

  var filters = headers.map(function (header) {
    return header['Filter'] && header.render('Filter');
  }).filter(function (filter) {
    return !!filter;
  }).map(function (filter, i) {
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: i
    }, filter);
  });
  return filters.length ? /*#__PURE__*/_react["default"].createElement(S.FilterContainer, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex flex-wrap flex-lg-nowrap justify-content-between"
  }, /*#__PURE__*/_react["default"].createElement(S.FilterManagement, {
    className: "align-items-end order-2 order-lg-1"
  }, filters, hasSelectedFilters && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-3"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-outline-success apply-filters",
    "data-testid": "apply-filter-button",
    onClick: function onClick() {
      onApplyFilters();
      gotoPage(0);
    }
  }, "Apply"), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn reset-filters",
    "data-testid": "reset-filter-button",
    onClick: function onClick() {
      setAllFilters({});
      onResetFilters();
      gotoPage(0);
    }
  }, "Reset"))), showFilterToggle && /*#__PURE__*/_react["default"].createElement(S.FilterManagement, {
    className: "justify-content-end order-1 order-lg-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-relative"
  }, /*#__PURE__*/_react["default"].createElement(S.FiltersButton, {
    className: "btn btn-sm btn-outline-secondary",
    type: "button",
    "data-testid": "filter-button",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, isOpen ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTimes.faTimes,
    className: "mr-2"
  }), "Close") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faFilter.faFilter,
    className: "mr-2"
  }), "Filters")), isOpen && /*#__PURE__*/_react["default"].createElement(S.FiltersList, null, filterOptions.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(S.FiltersOption, {
      key: i
    }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", {
      type: "checkbox",
      className: "mr-2",
      checked: selectedFilters[option.value],
      "data-testid": "filter-option-".concat(option.label.toLowerCase().replaceAll(' ', '-')),
      value: option.value,
      onChange: handleChange
    }), option.label));
  })))))) : null;
};

var _default = Filters;
exports["default"] = _default;